import React from "react";

export const RenameIcon = ({ color = "#113357", size = 20 }: { color?: string; size?: number }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 20 20">
      <path
        stroke={color}
        strokeWidth="1.2"
        d="M8.136 15H5.33a.33.33 0 0 1-.33-.33v-2.806a.33.33 0 0 1 .097-.233l6.994-6.995a2.314 2.314 0 1 1 3.273 3.273l-6.995 6.994a.33.33 0 0 1-.233.097ZM11 5l3.333 3.333"
      ></path>
    </svg>
  );
};

export const CimRenameIcon = ({ color = "#1e1e1e" }: { color?: string }) => {
  return (
    <div
      style={{ width: "10px", height: "10px", display: "flex", alignItems: "center", justifyContent: "center" }}
      data-testid="cim-rename-icon"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 11 11" fill="none">
        <path
          d="M3.03036 10L0.691992 10C0.540114 10 0.416992 9.87688 0.416992 9.725L0.416992 7.38664C0.416992 7.3137 0.445965 7.24375 0.497538 7.19218L6.32608 1.36364C7.0792 0.610521 8.30024 0.61052 9.05336 1.36364C9.80647 2.11675 9.80647 3.33779 9.05335 4.09091L3.22481 9.91945C3.17324 9.97103 3.10329 10 3.03036 10Z"
          stroke={color}
          strokeWidth="0.833333"
        />
        <path d="M5.41699 1.66602L8.19477 4.44379" stroke={color} strokeWidth="0.833333" />
      </svg>
    </div>
  );
};
